'use strict';

/** Import LocationHandler class */
import LocationHandler from '../utility/location_handler/location_handler'

/** Import APP_CONST */
import APP_CONST from '../../const';

/**
 * @class Cart
 */
class Cart
{
    /**
     * @constructor
     */
    constructor ()
    {
        this._storage = localStorage;
        this._removeCallback = null;
        if (!this._storage.getItem('cart'))
        {
            this._storage.setItem('cart', JSON.stringify([]));
        }
        if (!this._storage.getItem('cartTotal'))
        {
            this._storage.setItem('cartTotal', JSON.stringify({ totalItems: 0, delivery: 0, total: 0 }));
        }
    }

    /**
     * init
     */
    init ()
    {
        this._renderCart(this._getCart());
    }

    /**
     * @param callback
     */
    addRemoveCallback (callback)
    {
        this._removeCallback = callback;
    }

    /**
     * @return {any}
     */
    getCartItems ()
    {
        return this._getCart();
    }

    /**
     * @param item
     */
    addToCart (item)
    {
        let
            cart = this._getCart(),
            itemObj = this._prepareObject(item);

        if (parseInt(itemObj.price) > 0)
        {
            if (cart.length === 0)
            {
                cart.push(itemObj)
            } else {
                let alreadyInCart = false;
                $.each(cart, (a, b) =>
                {
                    if (b.slug === itemObj.slug)
                    {
                        if (itemObj.quantity < parseInt(itemObj.stock) && b.quantity < parseInt(itemObj.stock))
                        {
                            b.quantity = b.quantity + 1;
                        }
                        alreadyInCart = true;
                    }
                });
                if (!alreadyInCart)
                {
                    cart.push(itemObj)
                }
            }

            this._setCart(cart);
            this._renderCart(cart);
        }
    }

    /**
     * @param item
     */
    addToCartFromSinglePage (item)
    {
        let
            cart = this._getCart(),
            itemObj = this._prepareObject(item);

        if (parseInt(itemObj.price) > 0)
        {
            if (cart.length === 0)
            {
                cart.push(itemObj)
            } else {
                let alreadyInCart = false;
                $.each(cart, (a, b) =>
                {
                    if (b.slug === itemObj.slug)
                    {
                        if (itemObj.quantity <= parseInt(itemObj.stock))
                        {
                            b.quantity = itemObj.quantity;
                        }
                        alreadyInCart = true;
                    }
                });
                if (!alreadyInCart)
                {
                    cart.push(itemObj)
                }
            }

            this._setCart(cart);
            this._renderCart(cart);
        }
    }

    /**
     * @param itemSlug
     */
    removeFromCartList (itemSlug)
    {
        this._removeFromCart(itemSlug);
    }

    /**
     * @param slug
     * @param quantity
     */
    adjustQuantity (slug, quantity)
    {
        let
            tmp = [],
            cart = this._getCart();

        $.each(cart, (a, b) =>
        {
            if (b.slug === slug && quantity <= b.stock)
            {
                b.quantity = quantity;
            }
            if (parseInt(b.quantity) > 0)
            {
                tmp.push(b);
            }
        });
        cart = tmp;

        this._setCart(cart);
        this._renderCart(cart);
    }

    /**
     * @param totalItems
     * @param delivery
     * @param total
     */
    adjustDeliveryTotal (totalItems, delivery, total)
    {
        this._storage.setItem('cartTotal', JSON.stringify({ totalItems: totalItems, delivery: delivery, total: total }));
    }

    /**
     * @return {any}
     */
    getDeliveryTotal ()
    {
        return  JSON.parse(this._storage.getItem('cartTotal'));
    }

    /**
     * Clear cart data
     */
    clearCartData ()
    {
        this._clear();
        this._storage.removeItem('cartTotal');
        this._renderCart(this._getCart());
    }

    /**
     * @param cart
     * @private
     */
    _renderCart (cart)
    {
        let
            that = this,
            totalPrice = 0,
            html = '',
            totalItems = 0,
            imgPrefix = this.constructor._getImgPrefix();

        if (cart && cart.length > 0)
        {
            totalItems = cart.length;

            $.each(cart, (k, v) =>
            {
                let displayPrice = parseInt(v.price);
                if (APP_CONST.HIDDEN_DELIVERY === 'true')
                {
                    displayPrice = parseInt(displayPrice) + parseInt(v.delivery_price);
                }

                html += '<li class="item"><a href="#" class="product-media"><img src="' + imgPrefix + v.img + '" alt="img"></a>' +
                    '<div class="product-info">' +
                    '<div class="price">' + displayPrice + ' rsd x ' + v.quantity + '</div>' +
                    '<div class="product-name"><a href="' + imgPrefix + 'index.php/product/' + v.slug + '/details' + '">' + v.name + '</a></div>' +
                    '</div>' +
                    '<a href="#" class="remove cart-item-remove" data-slug="' + v.slug + '">x</a>' +
                    '</li>';

                totalPrice = totalPrice + (displayPrice * v.quantity);
            });
        }

        if (parseInt(totalItems) > 0)
        {
            $('#cart-view').removeAttr('style');
            $('#cart-payment').removeAttr('style');
        } else {
            $('#cart-view').attr('style', 'color: #FFF; cursor: not-allowed; opacity: 0.5; text-decoration: none;');
            $('#cart-payment').attr('style', 'color: #FFF; cursor: not-allowed; opacity: 0.5; text-decoration: none;');
        }

        $('#cart-total-items').empty().html(totalItems);
        $('#cart-item-list').empty().html(html);
        $('.cart-total-prices').empty().html(totalPrice + ' RSD');

        $('.cart-item-remove').unbind('click').on('click', (e) =>
        {
            let slug = $(e.target).data('slug');
            that._removeFromCart(slug);
        })
    }

    /**
     * @param itemSlug
     * @private
     */
    _removeFromCart (itemSlug)
    {
        let
            tmp = [],
            cart = this._getCart();

        $.each(cart, (a, b) =>
        {
            if (b.slug !== (itemSlug + ''))
            {
                tmp.push(b);
            }
        });
        cart = tmp;
        this._setCart(cart);
        this._renderCart(cart);

        if (this._removeCallback)
        {
            this._removeCallback();
        }
    }

    /**
     * @param item
     * @return {*}
     * @private
     */
    _prepareObject(item)
    {
        let
            itemObj = {},
            itemProps = ['slug','name','price','delivery_price','img','stock','quantity'],
            itemData = item.split('|');

        $.each(itemProps, (k,v) =>
        {
            let data = itemData[k];
            if (v === 'quantity' && !data)
            {
                data = 1;
            }
            itemObj[v] = data;
        });
        return itemObj;
    }

    /**
     * @param cart
     * @private
     */
    _setCart (cart)
    {
        this._storage.setItem('cart', JSON.stringify(cart));
    }

    /**
     * @return {any}
     * @private
     */
    _getCart ()
    {
        return  JSON.parse(this._storage.getItem('cart'));
    }

    /**
     * @private
     */
    _clear ()
    {
        this._storage.removeItem('cart');
    }

    /**
     * @return {string}
     * @private
     */
    static _getImgPrefix ()
    {
        let base = LocationHandler.getBaseUrl(), index = 'index.php';
        return base.substr(0, (base.length - index.length));
    }
}

/** @export Cart */
export default new Cart();



// WEBPACK FOOTER //
// ./assets/js/shared/cart/cart.js